import { render, staticRenderFns } from "./QuestionDivider.vue?vue&type=template&id=547aab30&scoped=true"
import script from "./QuestionDivider.vue?vue&type=script&lang=js"
export * from "./QuestionDivider.vue?vue&type=script&lang=js"
import style0 from "./QuestionDivider.vue?vue&type=style&index=0&id=547aab30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547aab30",
  null
  
)

export default component.exports